import { Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TermsPolicyDirective } from 'src/app/_shared/directive/terms-policy.directive';
import { UserState } from 'src/app/_shared/state/user.state';
import { AppState } from 'src/app/app.state';
import { ProfileService } from 'src/app/profile/profile.service';
import { SignupService } from 'src/app/signup/signup.service';
import { AgentContactState } from 'src/app/workspace/state/agent-contact.state';
import { PropertyState } from 'src/app/workspace/state/property.state';
import constants from 'src/constant.json';

interface DialogContent {
  proceedAction?: any;
  proceedCancelAction?: any;
  homeValueReportRequestData?: any;
}
interface CompanyPolicy {
  content: string;
  title: string;
  type: string;
}
@Component({
  selector: 'app-agent-contact-suggestion',
  templateUrl: './agent-contact-suggestion.component.html',
  styleUrls: ['./agent-contact-suggestion.component.scss'],
})
export class AgentContactSuggestionComponent implements OnInit, OnDestroy {
  @ViewChild('ctaPolicy') ctaPolicy: ElementRef;
  @ViewChildren(TermsPolicyDirective) termsAndPolicyDir;
  onDestroyNotifier$ = new Subject();
  enableSubmit = true;
  type: string;
  checkBox: boolean;
  policy: Partial<CompanyPolicy> = {};
  policyAgreement: Partial<CompanyPolicy> = {};
  companyPolicy: [];
  termsAndConditions: Partial<CompanyPolicy> = {};
  homeValueReportRequestForm: FormGroup;
  homeValueReportRequestInprogress: boolean;
  userProfile: any;
  showPassword: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AgentContactSuggestionComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DialogContent,
    private profileService: ProfileService,
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private agentContactState: AgentContactState,
    private appState: AppState,
    private propertyState: PropertyState,
    private signupService: SignupService,
    private snackBar: MatSnackBar,
    private userState: UserState
  ) {}

  ngAfterViewInit() {
    if (this.policyAgreement['content'] != null) {
      this.renderer.setProperty(this.ctaPolicy.nativeElement, 'innerHTML', this.policyAgreement['content']);
      this.renderer.listen(this.ctaPolicy.nativeElement.querySelector('#terms'), 'click', (event) => {
        this.termsAndPolicyDir.first.triggerPolicyView('terms');
      });
      this.renderer.listen(this.ctaPolicy.nativeElement.querySelector('#policy'), 'click', (event) => {
        this.termsAndPolicyDir.first.triggerPolicyView('policy');
      });
    }
  }

  ngOnInit(): void {
    this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) this.userProfile = res;
      this.userProfile = Object.assign({}, this.userProfile?.user_profile);
    });

    this.homeValueReportRequestForm = this.formBuilder.group({
      firstName: [
        { value: this.userProfile?.firstName || '', disabled: false },
        [Validators.required, Validators.pattern('[a-zA-Z ]*')],
      ],
      lastName: [
        { value: this.userProfile?.lastName || '', disabled: false },
        [Validators.required, Validators.pattern('[a-zA-Z ]*')],
      ],
      email: [
        { value: this.userProfile?.email || '', disabled: false },
        [Validators.required, Validators.pattern(constants.regex.validEmail)],
      ],
      phone: [
        { value: this.userProfile?.contact || '', disabled: false },
        [
          Validators.required,
          Validators.pattern('^(\\+\\d{1,2}\\s?)?1?\\-?\\.?\\s?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$'),
        ],
      ],
    });
    if (this.appState.authTokenValue?.idToken) {
      this.homeValueReportRequestForm.controls['email'].disable();
    }
    this.agentContactState.contactAgentRequestActionStatus$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res) => {
        this.homeValueReportRequestInprogress = res;
      });
    this.appState.companyInfo$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      if (res) {
        this.companyPolicy = res['companyPolicy'];
        this.companyPolicy.forEach((data: any) => {
          if (data['type'] === 'ctaPolicy') {
            this.policyAgreement.content = data.content;
            this.checkBox = true;
          } else {
            this.checkBox = false;
          }
        });
      }
    });
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
    this.agentContactState.contactAgentRequestActionStatusValue = false;
  }

  get homeValueReportRequestFormControls() {
    return this.homeValueReportRequestForm.controls;
  }

  requestHomeValue() {
    if (!this.appState.authTokenValue?.idToken && this.homeValueReportRequestForm.invalid) return;
    this.data.homeValueReportRequestData = this.homeValueReportRequestForm.getRawValue();

    if (this.appState.authTokenValue?.idToken) {
      (this.userProfile.email = this.homeValueReportRequestForm.value.email),
        (this.userProfile.firstName = this.homeValueReportRequestForm.value.firstName),
        (this.userProfile.lastName = this.homeValueReportRequestForm.value.lastName),
        (this.userProfile.contact = this.homeValueReportRequestForm.value.phone);
      if (this.homeValueReportRequestForm.invalid) return;
      this.profileService
        .updateUserBasicInfo(this.userProfile)
        .pipe(takeUntil(this.onDestroyNotifier$))
        .subscribe((res) => {
          if (res.message) {
            this.data.proceedAction(this.data.homeValueReportRequestData, () => {});
          }
        });
    } else {
      this.agentContactState.contactAgentRequestActionStatusValue = true;
      this.data.proceedAction(this.data.homeValueReportRequestData, () => {});
    }
  }

  close() {
    this.dialogRef.close();
  }

  openSnackBar(message, style) {
    if (message) {
      this.snackBar.open(message, '', {
        duration: 3000,
        panelClass: [style ? style : ''],
        verticalPosition: 'top',
      });
    }
  }

  // phoneValidator = (control) => {
  //   if (control.value != '') {
  //     const formatedValue = this.toNumberPipe.transform(control.value);
  //     if (formatedValue.toString().length == 10 || formatedValue.toString().length == 11) {
  //       console.log(formatedValue.toString().length);
  //       return null;
  //     } else return { phoneNumberInvalid: true };
  //   }
  // };
}
